import styled from 'styled-components'

const GenericIcon = styled.div`
  display: ${(props) => (props.display ? props.display : 'block')};
  position: ${(props) => (props.position ? props.position : 'relative')};
  top: ${(props) => (props.top ? props.top : 'unset')};
  left: ${(props) => (props.left ? props.left : 'unset')};
  right: ${(props) => (props.right ? props.right : 'unset')};
  bottom: ${(props) => (props.bottom ? props.bottom : 'unset')};
  margin: ${(props) => (props.margin ? props.margin : 'unset')};
  width: ${(props) => (props.width ? props.width : '100%')};
  height: ${(props) => (props.height ? props.height : '100%')};
  background-image: url(${(props) =>
    props.src
      ? props.src
      : 'https://cdn.business2community.com/wp-content/uploads/2017/12/Mobile_AD_FORMATS3-1.png'});
  margin: ${(props) => (props.margin ? props.margin : 'unset')};
  background-size: ${(props) =>
    props.backgroundSize ? props.backgroundSize : 'contain'};
  background-repeat: no-repeat;
  background-position: ${(props) =>
    props.backgroundPosition ? props.backgroundPosition : 'center'};
  z-index: ${(props) => (props.zIndex ? props.zIndex : '1')};
  border-radius: ${(props) =>
    props.borderRadius ? props.borderRadius : 'unset'};

  filter: drop-shadow(1px 3px 3px rgba(0, 0, 0, 0.25));

  &.active {
    opacity: 1;
  }

  &.inactive {
    opacity: 0.5;
  }

  &.player-icon {
    @media only screen and (max-device-width: 900px) and (orientation: landscape) {
      width: 3vw;
      height: 3vw;
    }
  }

  &.margin-right-auto {
    margin-right: auto;
  }

  &.button-style {
    transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    &:hover {
      cursor: pointer;
      transform: scale(1.1);
    }
  }

  &.mainpage-diet-banner {
    @media only screen and (max-width: 600px) {
      border-bottom-left-radius: 19px;
      border-bottom-right-radius: 19px;
    }
  }

  &.mainpage-diet-banner__second {
    @media only screen and (min-width: 601px) {
      border-bottom-right-radius: 19px;
      border-bottom-left-radius: 19px;
    }
  }

  &.mainpage-diet-banner__first {
    @media only screen and (min-width: 601px) {
      border-bottom-left-radius: 19px;
      background-position-y: 3 0%;
    }
  }

  /* &.navbar-icon,
  &.mainpage-switch-theme {
    width: 3vw;
      height: 3vw;
    @media (min-width: 1024px) and (max-width: 1280px) {
      width: 3vw;
      height: 3vw;
    }

    @media (min-width: 768px) and (max-width: 1023px) {
      width: 3vw;
      height: 3vw;
    }
  }

  &.miazga{
    width: 6vw;
      height: 3vw;
  } */
`

export default GenericIcon
